var Node = require('./node');


module.exports = Node.extend({

    defaults: function() {

        var base = _.result( Node.prototype,  'defaults' );

        return _.extend( base, {

            isApplied: false,
            isCollapsed: false,
            isMouseOver: false,
            nodeType: '' // 'PAGE', 'SEARCH', 'HIT' -- could set for root

        });

    },

    resetState: function() {

        this.set({
            isApplied: false,
            isCollapsed: false,
            isMouseOver: false
        }, { silent: true} );

    },

    isPageNode: function() {
        return this.get('nodeType') === 'PAGE';
    },

    isSearchNode: function() {
        return this.get('nodeType') === 'SEARCH';
    },

    isHitNode: function() {
        return this.get('nodeType') === 'HIT';
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/hierarchy/frResultNode.js
 ** module id = 661
 ** module chunks = 0
 **/